import { useT } from "../i18n/LanguageContext";

// Legal service disclaimer shown in the footer and at the end of each tour.
export function LegalDisclaimer({ className = "" }) {
  const t = useT();
  return (
    <p data-testid="legal-disclaimer" className={`text-white/40 text-xs leading-relaxed ${className}`}>
      {t("disclaimer.services")}
    </p>
  );
}
